"use strict";
var comp_ts_1 = require("./comp.ts");
var pwTemplate = require("./templates/dialogPW.handlebars");
var clientId = location.pathname, compCache = {}, compIndex = {}, dutyAuth = false, adminAuth = false;
// defualt the client name in testing this will need to be set up on the prod lobby.
if (window.location.hostname.indexOf("localhost") !== -1 && clientId === "/")
    clientId = "/banyule/";
var port = ""; // production.
if (window.location.hostname.indexOf("localhost") !== -1)
    port = ":8087";
var BASE_URL = "http://" + window.location.hostname + port + "/node" + clientId.slice(0, -1);
var hasDutyAuth = false;
function innerGet(url) {
    var completeURL = BASE_URL + url;
    console.log("loading: " + completeURL);
    var start = (new Date()).getTime();
    return Promise.resolve($.ajax({
        type: "GET",
        //headers: {  //Problem with this approche is that it causes a preflight OPTION request before EVERY call. Better solution is to get users to refresh manually.
        //	"Cache-Control" : "max-age=0" // This will mean that every call goes back to the CDN as if the user performed a refresh.
        //},
        xhrFields: { withCredentials: true },
        url: completeURL,
        dataType: "text"
    })).then(function (value) {
        var jsonObj;
        try {
            jsonObj = JSON.parse(value);
        }
        catch (e) {
            console.log("Error " + e + "parsing value: " + value);
        }
        console.log(completeURL + " took: " + ((new Date()).getTime() - start) + "ms");
        return jsonObj;
    });
}
function innerPost(url, data) {
    var completeURL = BASE_URL + url, start = new Date().getTime();
    console.log("posting to: " + completeURL);
    return Promise.resolve($.ajax({
        url: completeURL,
        async: true,
        type: "POST",
        crossDomain: true,
        xhrFields: { withCredentials: true },
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json"
    }))
        .then(function (result) {
        console.log("post " + completeURL + " took " + (new Date().getTime() - start) + "ms");
        return result;
    }).catch(function (error) {
        if (error.status === 401) {
            return showDutyLogin().then(function () {
                return innerPost(url, data);
            });
        }
        window["bootbox"].alert("Network Error (" + error.status + "): Please refresh your browser and try again.");
        throw error;
    });
}
function showDutyLogin() {
    return new Promise(function (resolve, reject) {
        window["bootbox"].dialog({
            title: "Enter the duty password:",
            message: pwTemplate(),
            buttons: {
                success: {
                    label: "Perform Duty",
                    className: "btn-success",
                    callback: function () {
                        var pw = $("#password").val();
                        login("duty", pw).then(function (r) {
                            if (r === true) {
                                hasDutyAuth = true;
                                resolve();
                            }
                            else
                                reject();
                        });
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-normal",
                    callback: function () {
                        reject();
                    }
                }
            }
        });
    });
}
module.exports.getIndex = function () {
    var values = _.values(compIndex);
    if (values.length > 0)
        return Promise.resolve(values);
    return innerGet("/").then(function (result) {
        _.forEach(result, function (row) {
            compIndex[row.id] = row;
        });
        return result;
    });
};
module.exports.getComp = function (compId) {
    // if its already loaded just create a promise and return.
    if (compCache[compId] !== undefined)
        return Promise.resolve(compCache[compId]);
    // otherwise load it from the database.
    return innerGet("/" + compId).then(function (val) {
        // assumes that the index is loaded first.
        var grade = compIndex[compId].grade;
        var season = compIndex[compId].season;
        var comp = new comp_ts_1.Comp(compId, season, grade, val["games"], val["teams"], val["goals"], val["players"]);
        compCache[compId] = comp;
        return comp;
    });
};
module.exports.isDutyAuth = function () { return (dutyAuth === true); };
module.exports.isAdminAuth = function () { return (adminAuth === true); };
function login(username, pw) {
    var data = {
        "username": username,
        "password": pw
    };
    return innerPost("/login", data)
        .then(function (r) {
        dutyAuth = r["dutyAuth"];
        adminAuth = r["adminAuth"];
        return true;
    })
        .catch(function (r) {
        return false;
    });
}
module.exports.removeGoal = function (compId, gameId, teamId, position) {
    return innerPost("/" + compId + "/" + gameId + "/" + teamId + "/" + position + "/removeGoal", {})
        .then(function (newGameJson) {
        var newGame = compCache[compId].updateGame(newGameJson);
        return newGame;
    });
};
module.exports.addGoal = function (compId, gameId, teamId, gameState, position) {
    return innerPost("/" + compId + "/" + gameId + "/" + teamId + "/" + gameState + "/" + position + "/addGoal", {})
        .then(function (newGameJson) {
        var newGame = compCache[compId].updateGame(newGameJson);
        return newGame;
    });
};
module.exports.hasDutyAuth = function () { return hasDutyAuth; };
module.exports.showDutyLogin = showDutyLogin;
module.exports.login = login;



/*****************
 ** WEBPACK FOOTER
 ** ./src/restAPI.ts
 ** module id = 56
 ** module chunks = 1
 **/